<template>
	<div class="infor fl">
		<div class="infor-t clearfix">
			<div class="fl infor-t-l">更改密码</div>
		</div>
		<div v-if="!issuccess" class="">
  
                    <div class="login">
                        <div class="login-form">
                            <div>
                                <label class="login-form-lable">旧密码</label>
                                <input class="login-form_item" name="oldpwd" placeholder="请输入旧密码" type="password" v-model="oldpwd" />
                            </div>
                            <div v-if="wPaw" class="font-wraing">
                                <img class="wraing-icon" src="../assets/3.png" /><span>{{wPaw}}</span>
                            </div>
                            <div>
                                <label class="login-form-lable">新密码</label>
                                <input class="login-form_item" name="newpaw" placeholder="请输入新密码" type="password"
                                       v-model="newpaw" />
                            </div>
                            <div v-if="wPaw" class="font-wraing">
                                <img class="wraing-icon" src="../assets/3.png" /><span>{{wnPaw}}</span>
                            </div>
                            <div>
                                <label class="login-form-lable">确认新密码</label>
                                <input class="login-form_item" name="renewpaw" placeholder="请再次输入新密码" type="password"
                                       v-model="renewpaw" />
                            </div>
                            <div v-if="wNewPaw" class="font-wraing">
                                <img class="wraing-icon" src="../assets/3.png" /><span>{{wNewPaw}}</span>
                            </div>
                            <button class="login-but" @click="login">确认修改</button>
                        </div>
                    </div>
		</div>
        <div v-else class="shenhjrkr">
            <img src="../assets/failesucee.png" alt />
            <p style="font-size: 20px;color:#333333">更新成功，请重新登录</p>
            <p style="font-size: 16px;color: #9FA5AE;margin: 10px 0">{{redirectCount}}s后为您跳转到登录页</p>
            <div class="flex-left">
                <el-button
                    size="small"
                    style="color:#194ABE;border:1px solid #194ABE;width:189px;height:50px;font-size:18px;margin-top:50px;background:#fff;margin:0 auto"
                    class="block-submit"
                    @click="toLogin"
                >立即跳转</el-button>
            </div>
            <div>
            </div>
        </div>
	</div>
</template>

<script>
import {expertModifyPwd} from "../utils/api.js"
import {IsCode, IsCode2, IsPaw, IsPawCompare, IsTel, IsTel2} from "../utils/validate";
	export default {
		name: "expertpwd",
		components: {
		},
		data() {
			return {
                issuccess:false,
                activeName: 'first',
                wPaw: "", //密码提示
                oldpwd:"",
                newpaw: "",
                renewpaw:"",
                wNewPaw: "", //确认密码
                wnPaw:"",
                show: true,
                count: '',
                timer: null,
                timer2:null,
                redirectCount:5,
                token:''
			}
		},
		async mounted() {
            let user = JSON.parse(localStorage.getItem("USERDATE"));
			this.token = 'Bearer ' + localStorage.getItem("TOKEN");

		},
		methods: {
            handleClick(tab, event) {
                console.log(tab, event);
			},
            
            login() {
                if (
                    IsPaw(this, this.oldpwd, "请输入旧密码") &&
                    IsPawCompare(this, this.newpaw, "新密码", this.renewpaw)
                ) {
                    console.log("校验通过");
                    const data = {
                        "oldpwd": this.oldpwd,
                        "newpwd": this.newpaw
                    }
                    expertModifyPwd(data).then(res => {
                        console.log(res)
                        this.$message({
                            message: '设置成功',
                            type: 'success'
                        });
                        localStorage.removeItem('TOKEN');
                        this.saveSuccess();
                    }).catch(err => {
                        this.$message.error(err);
                    })
                }
            },
            saveSuccess(){
                this.issuccess = true;
                this.timer2 = setInterval(() => {
                    if (this.redirectCount > 0 && this.redirectCount <= 5) {
                        this.redirectCount--;
                    } else {
                        clearInterval(this.timer2);
                        this.timer2 = null;
                        this.toLogin();
                    }
                }, 1000)
            },
            toLogin(){
                this.$router.push('/expert');
                localStorage.removeItem('TOKEN')
            }
		}
	}
</script>

<style lang="less" scoped>
	.infor {
		width: 858px;
		height: 800px;
		padding: 0px 30px 40px 30px;
		background: #fff;
		border-radius: 6px;
		margin-left: 14px;
		margin-bottom: 34px;
		position: relative;

		&-t {
			// padding: 14px;
			padding-top: 14px;
			border-bottom: 1px solid #D4DBDD;

			&-l {
				font-size: 28px;
				color: #181e23;
				display: inline-block;
				padding-bottom: 14px;
				font-weight: bold;
				// border-bottom: 2px solid #194abe;
			}

			&-r {
				width: 140px;
				height: 31px;
				background: #E51725;
				opacity: 1;
				overflow: hidden;
				display: table-cell;
				line-height: 31px;
				border-radius: 6px;
				cursor: pointer;

				img {
					vertical-align: middle;
					margin-right: 6px;
				}

				span {
					color: #FFFFFF;
					font-size: 14px;
				}
			}
		}

		&-c {
			text-align: justify;
			font-size: 16px;
			font-family: Microsoft YaHei;
			font-weight: 400;
			line-height: 32px;
			color: #565656;
			padding: 10px 0px;
		}

		&-img {
			text-align: center;
			padding: 24px 0px 40px 0px;
		}


	}

    .login {
        text-align: left;
        .login-form {
            width: 658px;
            //  height: 473px;
            background: #fff;
            margin: 0 auto;
            padding: 20px 20px 40px 22px;

            .login-form-lable {
                display: inline-block;
                width: 70px;
                color: #757575;
                font-size: 14px;
                text-align: right;
            }

            &_title {
                color: #272f3c;
                font-size: 24px;
                font-weight: bold;
                line-height: 26px;
                text-align: left;
                border-bottom: 1px solid #dbdbdb;
                padding-bottom: 18px;
            }

            &_item {
                width: 280px;
                height: 42px;
                border: 1px solid #bdc3cb;
                padding: 0px 11px;
                font-size: 14px;
                margin-left: 12px;
                margin-top: 10px;
            }

            .margin-top-29 {
                margin-top: 29px;
            }

            .pos-input {
                position: relative;

                .margin-top-0 {
                    margin-top: 0px;
                }

                .code-block {
                    position: absolute;
                    top: 10px;
                    right: 136px;
                    width: 102px;
                    height: 42px;
                    text-align: center;
                    line-height: 42px;
                    color: #194abe;
                    border: 1px solid #194abe;
                    font-size: 14px;
                    cursor: pointer;
                }
            }

            .login-form_assist {
                width: 280px;
                //   height: 60px;
                //  line-height: 60px;
                margin-top: 15px;
                // margin-left: 32px;
                margin-bottom: 19px;
                vertical-align: middle;

                &_isAgree {
                    display: inline-block;

                    margin-right: 8px;
                }

                &_isAgree:checked::after {
                    background: crimson;
                }

                a {
                    float: right;
                    text-decoration: underline;
                    color: #71767c;
                    font-size: 14px;
                }
            }

            .login-but {
                width: 302px;
                height: 48px;
                background: #194abe;
                opacity: 1;
                border-radius: 6px;
                // margin-left: 32px;
                color: #fff;
                font-size: 16px;
                font-weight: bold;
                border: none;
                cursor: pointer;

                margin-left: 80px;
                margin-top: 31px;
            }

            .login-clear {
                width: 302px;
                height: 48px;
                background: #fff;
                opacity: 1;
                border-radius: 6px;
                // margin-left: 32px;
                color: #7c828a;
                font-size: 16px;
                font-weight: bold;
                border: none;
                cursor: pointer;
                border: 1px solid #7c828a;
                margin-left: 80px;
                margin-top: 14px;
            }

            .login-register {
                width: 280px;
                height: 48px;
                background: #ffffff;
                opacity: 1;
                border-radius: 6px;
                // margin-left: 32px;
                color: #194abe;
                font-size: 16px;
                font-weight: bold;
                margin-top: 24px;
                text-align: center;
                line-height: 48px;
                border: 1px solid #194abe;
                cursor: pointer;
                border-radius: 6px;
            }

            .font-wraing {
                color: #ff7476;
                font-size: 14px;
                margin-left: 84px;
                margin-top: 6px;
                text-align: left;
            }

            .wraing-icon {
                display: inline-block;
                margin-right: 10px;
            }
        }
    }
    .shenhjrkr {
        margin: 71px 0 100px 0;

        img {
            width: 120px;
        }
    }
</style>
